export enum AppointmentState {
  initial = 'initial',
  expired = 'expired',
  started = 'started',
  scheduled = 'scheduled',
  completed = 'completed',
  cancelled = 'cancelled',
  submitted = 'submited',
  refunded = 'refunded',
  failed = 'failed',
  payed = 'payed',
}

// transform enum values to union type
export type SessionState = `${AppointmentState}`;


export type SessionStateToChange = 'canceled' | 'rescheduled';
